import { map } from 'rxjs/operators';
import { UserResponse, AccountResponse } from '@business/entities/account';
import { Endpoint, getMakhAuth } from '../endpoint';
import { R } from '@core/utils/r';

export function loginForAccounts(email: string, password: string, remember = false) {
  const data = { email, password, keepalive: remember };
  return Endpoint.post<AccountResponse[]>('@makh/auth/accounts', { data });
}

export function login(email: string, password: string, remember = false) {
  const data = { email, password, keepalive: remember };

  return Endpoint.post<UserResponse>('@makh/auth/login', { data });
}

export function switchAccount(email: string, appId: string) {
  const data = { email, appId };

  return Endpoint.post<UserResponse>('@makh/auth/switch', { data });
}

export function check(token: string) {
  return Endpoint.get<UserResponse>('@makh/auth/check', { auth: getMakhAuth(token) }).pipe(map(user => ({ user })));
}

export function reset(email: string) {
  const data = { email };

  return Endpoint.post<void>('@makh/auth/reset', { data });
}

export function setPassword(email: string, password: string, password_confirmation: string, token: string) {
  const data = { email, password, password_confirmation, token };

  return Endpoint.post<void>('@makh/auth/set-password', { data });
}

export function activate(password: string, password_confirmation: string, token: string) {
  const data = { password, password_confirmation, token };

  return Endpoint.post<void>('@makh/auth/activate', { data });
}

export function controlAccount(appId: string) {
  const data = R.objectCompact({ appId });

  return Endpoint.post<UserResponse>('@makh/auth/control', { data });
}

export function controlAccountByEmail(appId: string, email: string, token: string) {
  const data = R.objectCompact({ email, appId, token });
  return Endpoint.post<UserResponse>('@makh/auth/control-by-email', { data });
}

export interface LoginUrlResponse {
  url: string;
}
export function getLoginUrl(appId: string, email: string) {
  const data = { appId, email };

  return Endpoint.post<LoginUrlResponse>('@makh/auth/login-url', { data });
}
